import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    dataSelectCatalog: [],
    parentColumnName: null,
    hasParent: false,
    catalogRowId: null,
    dataModal: null
}

export const catalogsSlice = createSlice({
    name: 'catalogs',
    initialState,
    reducers: {
        setDataSelectCatalog: (state, { payload }) => {
            state.dataSelectCatalog = payload
        },
        setParentColumnName: (state, { payload }) => {
            state.parentColumnName = payload
        },
        setHasParent: (state, { payload }) => {
            state.hasParent = payload
        },
        setCatalogRowId: (state, { payload }) => {
            state.catalogRowId = payload
        },
        setDataModal: (state, { payload }) => {
            state.dataModal = payload
        }
    }
})

export const { setDataSelectCatalog, setParentColumnName, setHasParent, setCatalogRowId, setDataModal } =
    catalogsSlice.actions
export default catalogsSlice.reducer
